import React from "react";
import { Button, RadioGroup, Card, CardContent, Divider, Fab, FormControl, FormControlLabel, MenuItem, Radio, Stack, Switch, TextField, Grow, Grid, ButtonGroup, TableRow, TableBody } from "@material-ui/core";
import {
  Typography,
  Box,
} from "@material-ui/core";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import { goToLogin, goToUsers } from "../../routes/Coordinator";
import AddIcon from '@mui/icons-material/Add';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import useForm from "../../hooks/useForm";
import axios from "axios";
import { useEffect } from "react";
import Alert from '@mui/material/Alert';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import Paper from '@mui/material/Paper';
import Pagination from '@mui/material/Pagination';
import { format } from 'date-fns'
import { styled } from '@mui/material/styles';
import Table from '@mui/material/Table';


export const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: '#2A858B',
    color: theme.palette.common.white,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));
export const StyledTableRow = styled(TableRow)(({ theme }) => ({
  '&:nth-of-type(odd)': {
    backgroundColor: theme.palette.action.hover,
  },
  // hide last border
  '&:last-child td, &:last-child th': {
    border: 0,
  },
}));
const naturezaList = [
  {
    value: "todos",
    label: "Todos",
  },
  {
    value: "inflow",
    label: "Receita",
  },
  {
    value: "outflow",
    label: "Despesa",
  },
];

const optionList = [
  {
    value: "todos",
    label: "Todos",
  },
  {
    value: "cashbook",
    label: "Livro Caixa",
  },
  {
    value: "income_tax",
    label: "Imposto de Renda",
  },
  {
    value: "cash_outflow",
    label: "Despesa Fluxo de Caixa",
  },
];
const printList= [
  {
    value: "pdf",
    label: "Imprimir em PDF",
  },
  {
    value: "xls",
    label: "Imprimir em XLS",
  },
];
export const divStyle = {
  overflowX: 'auto',
  width: '65vw',
  position: 'relative'
};
const ControlPage = () => {
  const [open, setOpen] = React.useState(false);
  const anchorRef = React.useRef(null);
  const [selectedIndex, setSelectedIndex] = React.useState(1);
  const [rows, setRows] = useState([])
  const [doctors, setDoctors] = useState([])
  const [totalPages, setTotalPages] = useState(1)
  const [nature, setNature] = useState("")
  const [option, setOption] = useState("")
  const [formato, setFormato] = useState("")
  const [year, setYear] = useState(new Date().getFullYear())
  const [month, setMonth] = useState("")
  const [doctor_id, setDoctorId] = useState("")
  const [currentButton1, setCurrentButton1] = useState('outlined');
  const [currentButton2, setCurrentButton2] = useState('outlined');
  const [currentButton3, setCurrentButton3] = useState('outlined');
  const [currentButton4, setCurrentButton4] = useState('outlined');
  const [currentButton5, setCurrentButton5] = useState('outlined');
  const [currentButton6, setCurrentButton6] = useState('outlined');
  const [currentButton7, setCurrentButton7] = useState('outlined');
  const [currentButton8, setCurrentButton8] = useState('outlined');
  const [currentButton9, setCurrentButton9] = useState('outlined');
  const [currentButton10, setCurrentButton10] = useState('outlined');
  const [currentButton11, setCurrentButton11] = useState('outlined');
  const [currentButton12, setCurrentButton12] = useState('outlined');
  const [valorTotal, setValorTotal] = useState([])
  const [margin, setMargin] = useState("")
  const navigate = useNavigate();

  const years = () => {
    let years = []
    for (let index = 2019; index <= new Date().getFullYear(); index++) {
      years.push(index)

    }
    return years
  }

  const Doctors = () => {
    let url = `${process.env.REACT_APP_BASE_URL}/doctors`


    axios.get(url, {
      params: { all: true },

      headers: {
        "access-token": localStorage.getItem("access-token"),
        "client": localStorage.getItem("client"),
        "expiry": localStorage.getItem("expiry"),
        "token-type": localStorage.getItem("token-type"),
        "uid": localStorage.getItem("uid"),
        "Content-Type": "application/json"
      }
    })
      .then(response => {
        setDoctors(response.data.doctors)
        setTotalPages(response.data.meta.total_pages)

      })
      .catch(erro => {
        Object.keys(erro.response.data).forEach((item) => {
          alert(erro.response.data[item]);
        });
        if (erro.response.status === 401) {
          goToLogin(navigate)
        }
      })
  }
  useEffect(() => {
    Doctors()
  }, [])

  const Search = () => {
    let url = `${process.env.REACT_APP_BASE_URL}/transactions_control?page=1`

    if (nature && nature !== 'todos') {
      url = `${url}&nature=${nature}`
    }
    if (option && option !== 'todos') {
      url = `${url}&option=${option}`
    }
    if (doctor_id) {
      url = `${url}&doctor_id=${doctor_id}`
    }
    if (year) {
      url = `${url}&year=${year}`
    }
    if (month) {
      url = `${url}&month=${month}`
    }

    axios.get(url,
      {
        headers: {
          "access-token": localStorage.getItem("access-token"),
          "client": localStorage.getItem("client"),
          "expiry": localStorage.getItem("expiry"),
          "token-type": localStorage.getItem("token-type"),
          "uid": localStorage.getItem("uid"),
          "Content-Type": "application/json"
        }
      })
      .then(response => {
        setRows(response.data.transactions)
        setTotalPages(response.data.meta.total_pages)
        setValorTotal(response.data.meta.total_value)
        setMargin(response.data.meta.available_margin)
      })
      .catch(erro => {
        Object.keys(erro.response.data).forEach((item) => {
          alert(erro.response.data[item]);
        });
      })
  }
  const SearchPDFUrl = () => {
    let url = `${process.env.REACT_APP_BASE_URL}/transactions_control.${formato}?doctor_id=${doctor_id}`

    if (nature && nature !== 'todos') {
      url = `${url}&nature=${nature}`
    }
    if (year) {
      url = `${url}&year=${year}`
    }
    if (month) {
      url = `${url}&month=${month}`
    }

    return url
  }
  const SearchMonth = (month, e) => {
    setMonth(month)
    let url = `${process.env.REACT_APP_BASE_URL}/transactions_control?page=1&month=${month}`

    if (nature) {
      url = `${url}&nature=${nature}`
    }
    if (doctor_id) {
      url = `${url}&doctor_id=${doctor_id}`
    }
    if (year) {
      url = `${url}&year=${year}`
    }
    if (month === 1) {
      setCurrentButton1('contained');
    }
    else {
      setCurrentButton1('outlined');
    }
    if (month === 2) {
      setCurrentButton2('contained');
    }
    else {
      setCurrentButton2('outlined');
    }
    if (month === 3) {
      setCurrentButton3('contained');
    }
    else {
      setCurrentButton3('outlined');
    }
    if (month === 4) {
      setCurrentButton4('contained');
    }
    else {
      setCurrentButton4('outlined');
    }
    if (month === 5) {
      setCurrentButton5('contained');
    }
    else {
      setCurrentButton5('outlined');
    }
    if (month === 6) {
      setCurrentButton6('contained');
    }
    else {
      setCurrentButton6('outlined');
    }
    if (month === 7) {
      setCurrentButton7('contained');
    }
    else {
      setCurrentButton7('outlined');
    }
    if (month === 8) {
      setCurrentButton8('contained');
    }
    else {
      setCurrentButton8('outlined');
    }
    if (month === 9) {
      setCurrentButton9('contained');
    }
    else {
      setCurrentButton9('outlined');
    }
    if (month === 10) {
      setCurrentButton10('contained');
    }
    else {
      setCurrentButton10('outlined');
    }
    if (month === 11) {
      setCurrentButton11('contained');
    }
    else {
      setCurrentButton11('outlined');
    }
    if (month === 12) {
      setCurrentButton12('contained');
    }
    else {
      setCurrentButton12('outlined');
    }


    axios.get(url,
      {
        headers: {
          "access-token": localStorage.getItem("access-token"),
          "client": localStorage.getItem("client"),
          "expiry": localStorage.getItem("expiry"),
          "token-type": localStorage.getItem("token-type"),
          "uid": localStorage.getItem("uid"),
          "Content-Type": "application/json"
        }
      })
      .then(response => {
        setRows(response.data.transactions)
        setTotalPages(response.data.meta.total_pages)
        setValorTotal(response.data.meta.total_value)
        setMargin(response.data.meta.available_margin)
      })
      .catch(erro => {
        Object.keys(erro.response.data).forEach((item) => {
          alert(erro.response.data[item]);
        });
      })
  }
  const SearchYear = (year, e) => {
    setYear(year)
    let url = `${process.env.REACT_APP_BASE_URL}/transactions_control?page=1&year=${year}`

    if (nature) {
      url = `${url}&nature=${nature}`
    }
    if (doctor_id) {
      url = `${url}&doctor_id=${doctor_id}`
    }
    if (month) {
      url = `${url}&month=${month}`
    }


    axios.get(url,
      {
        headers: {
          "access-token": localStorage.getItem("access-token"),
          "client": localStorage.getItem("client"),
          "expiry": localStorage.getItem("expiry"),
          "token-type": localStorage.getItem("token-type"),
          "uid": localStorage.getItem("uid"),
          "Content-Type": "application/json"
        }
      })
      .then(response => {
        setRows(response.data.transactions)
        setTotalPages(response.data.meta.total_pages)
      })
      .catch(erro => {
        Object.keys(erro.response.data).forEach((item) => {
          alert(erro.response.data[item]);
        });
      })
  }
  const handleChange = (event, page) => {
    let url = `${process.env.REACT_APP_BASE_URL}/transactions_control?page=${page}`

    if (nature) {
      url = `${url}&nature=${nature}`
    }
    if (doctor_id) {
      url = `${url}&doctor_id=${doctor_id}`
    }
    if (year) {
      url = `${url}&year=${year}`
    }
    if (month) {
      url = `${url}&month=${month}`
    }

    axios.get(url,
      {
        headers: {
          "access-token": localStorage.getItem("access-token"),
          "client": localStorage.getItem("client"),
          "expiry": localStorage.getItem("expiry"),
          "token-type": localStorage.getItem("token-type"),
          "uid": localStorage.getItem("uid"),
          "Content-Type": "application/json"
        }
      })
      .then(response => {
        setRows(response.data.transactions)
        setTotalPages(response.data.meta.total_pages)

      })
      .catch(erro => {
        Object.keys(erro.response.data).forEach((item) => {
          alert(erro.response.data[item]);
        });
      })
  };
  const EditAccounting = (accounting, id) => {

    let url = `${process.env.REACT_APP_BASE_URL}/transactions/${id}/update_accounting`
    axios.patch(url, { transaction: { accounting } },
      {
        headers: {
          "access-token": localStorage.getItem("access-token"),
          "client": localStorage.getItem("client"),
          "expiry": localStorage.getItem("expiry"),
          "token-type": localStorage.getItem("token-type"),
          "uid": localStorage.getItem("uid"),
          "Content-Type": "application/json"
        }
      })
      .then(response => {
        Search()
      })
      .catch(erro => {
        Object.keys(erro.response.data).forEach((item) => {
          alert(erro.response.data[item]);
        });
      })
  }
  const handleChangeChecked = (accounting, id) => {
    EditAccounting(accounting, id)
  };
  return (
    <Box>
      <Card variant="outlined">
        <CardContent>
          <Typography variant="h3" sx={{ mb: 2 }}>Controle</Typography>
          <Divider />
          <form>
            <CardContent
              sx={{
                padding: "30px",
              }}
            >
              <Grid container rowSpacing={2} columnSpacing={3}>
                <Grid item xs={12} md={12} lg={3}>
                  <TextField
                    fullWidth
                    select
                    label="Natureza"
                    onChange={(e) => setNature(e.target.value)}
                    value={nature}
                    name={"nature"}
                    type={"nature"}
                  >
                    {naturezaList.map((option) => (
                      <MenuItem key={option.value} value={option.value}>
                        {option.label}
                      </MenuItem>
                    ))}
                  </TextField>
                </Grid>
                <Grid item xs={12} md={12} lg={3}>
                  <TextField
                    fullWidth
                    select
                    label="Opção"
                    onChange={(e) => setOption(e.target.value)}
                    value={option}
                    type={"option"}
                    name="role"
                  >
                    {optionList.map((option) => (
                      <MenuItem key={option.value} value={option.value}>
                        {option.label}
                      </MenuItem>
                    ))}
                  </TextField>
                </Grid>
                <Grid item xs={12} md={12} lg={6}>
                  <TextField
                    fullWidth
                    select
                    required
                    id="function"
                    label="Selecione o Médico"
                    onChange={(e) => setDoctorId(e.target.value)}
                    value={doctor_id}
                    name={"doctor_id"}
                    type={"doctor_id"}
                  >
                    {doctors.map((doctor) => (
                      <MenuItem key={doctor.id} value={doctor.id}>
                        {doctor.name}
                      </MenuItem>
                    ))}
                  </TextField>
                </Grid>

                <Grid item xs={12} md={12} lg={6}>
                  {(margin === 0 || margin) &&
                    <TextField
                      sx={{ width: '100%' }}
                      label={"Margem disponível"}
                      name={"margin"}
                      id="outlined-required"
                      disabled
                      value={margin.toLocaleString("pt-br", { style: "currency", currency: "BRL" })}
                      type={"margin"}
                    />
                  }
                </Grid>

                <Grid item xs={12} md={12} lg={6}>

                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "flex-end"
                    }}
                  >
                    <Box>
                      <Button onClick={() => Search()} variant="contained" >
                        Pesquisar
                      </Button>
                    </Box>
                  </Box>
                </Grid>
              </Grid>

            </CardContent>

          </form>
          <Typography variant="h3" sx={{ mb: 2 }}>Relatório por Período</Typography>
          <Divider />

          <form>
            <CardContent
              sx={{
                padding: "30px",
              }}

            >
              <Grid container rowSpacing={2} columnSpacing={3}>
                <Grid item xs={12} md={2} lg={3} >
                  <TextField
                    fullWidth
                    id="function"
                    onChange={(e) => SearchYear(e.target.value)}
                    value={year}
                    name={"year"}
                    type={"year"}
                    select
                    size="small"
                  >
                    {years().map((year) =>
                      <MenuItem value={year}>{year}</MenuItem>
                    )}
                  </TextField>
                </Grid>
                <Grid item xs={12} md={8} lg={8} >
                  <ButtonGroup
                    onChange={(e) => setMonth(e.target.value)}
                    value={month}
                    variant="outlined"
                    aria-label="outlined button group">
                    <Button sx={{ padding: '7px 5px' }} variant={currentButton1} onClick={(e) => SearchMonth(1, e)}>JAN</Button>
                    <Button sx={{ padding: '7px 5px' }} variant={currentButton2} onClick={(e) => SearchMonth(2, e)}>FEV</Button>
                    <Button sx={{ padding: '7px 5px' }} variant={currentButton3} onClick={(e) => SearchMonth(3, e)}>MAR</Button>
                    <Button sx={{ padding: '7px 5px' }} variant={currentButton4} onClick={(e) => SearchMonth(4, e)}>ABR</Button>
                    <Button sx={{ padding: '7px 5px' }} variant={currentButton5} onClick={(e) => SearchMonth(5, e)}>MAI</Button>
                    <Button sx={{ padding: '7px 5px' }} variant={currentButton6} onClick={(e) => SearchMonth(6, e)}>JUN</Button>
                    <Button sx={{ padding: '7px 5px' }} variant={currentButton7} onClick={(e) => SearchMonth(7, e)}>JUL</Button>
                    <Button sx={{ padding: '7px 5px' }} variant={currentButton8} onClick={(e) => SearchMonth(8, e)}>AGO</Button>
                    <Button sx={{ padding: '7px 5px' }} variant={currentButton9} onClick={(e) => SearchMonth(9, e)}>SET</Button>
                    <Button sx={{ padding: '7px 5px' }} variant={currentButton10} onClick={(e) => SearchMonth(10, e)}>OUT</Button>
                    <Button sx={{ padding: '7px 5px' }} variant={currentButton11} onClick={(e) => SearchMonth(11, e)}>NOV</Button>
                    <Button sx={{ padding: '7px 5px' }} variant={currentButton12} onClick={(e) => SearchMonth(12, e)}>DEZ</Button>
                  </ButtonGroup>
                </Grid>
                <Grid item xs={12} md={2} lg={3}>
                <TextField
                fullWidth
                  select
                  size="small"
                  label="Formato de impressão"
                  onChange={(e) => setFormato(e.target.value)}
                  value={formato}
                  type={"formato"}
                  name="formato"
                >
                 {printList.map((list) => (
                    <MenuItem key={list.value} value={list.value}>
                      {list.label}
                    </MenuItem>
                  ))}
                </TextField>
              </Grid>
                <Grid item xs={12} md={2} lg={2}>

                  <Button target={'_blank'} href={SearchPDFUrl()} variant="contained" color="success"  >
                    Imprimir
                  </Button>
                </Grid>
              </Grid>
            </CardContent>
          </form>
        </CardContent>
      </Card>

      {
        rows.length === 0 &&
        <CardContent
          sx={{
            padding: "30px",
          }}
        >
          <Grid container rowSpacing={2} columnSpacing={3}>
            <Grid item xs={12} md={12} lg={12}>
              <Stack >
                <Alert severity="warning">Nenhum registro encontrado!</Alert>
              </Stack>
            </Grid>
          </Grid>
        </CardContent>
      }
      {rows.length > 0 &&
      <Card variant="outlined">
      <CardContent>
        <Box
          sx={{
            overflow: {
              xs: "auto",
              sm: "unset",
            },
          }}
        >
          <Table
            aria-label="simple table"
            sx={{
              mt: 3,
            }}
          >
            <TableHead>
              <TableRow>
                <TableCell>
                  <Typography color="textSecondary" variant="h6">
                    Data de Lançamento
                  </Typography>
                </TableCell>
                <TableCell>
                  <Typography color="textSecondary" variant="h6">
                    Fornecedor/Paciente
                  </Typography>
                </TableCell>
                <TableCell>
                  <Typography color="textSecondary" variant="h6">
                    Número do Documento
                  </Typography>
                </TableCell>
                <TableCell>
                  <Typography color="textSecondary" variant="h6">
                    Opção
                  </Typography>
                </TableCell>
                <TableCell>
                  <Typography color="textSecondary" variant="h6">
                    Tipo
                  </Typography>
                </TableCell>
                <TableCell>
                  <Typography color="textSecondary" variant="h6">
                    Valor
                  </Typography>
                </TableCell>
                <TableCell>
                  <Typography color="textSecondary" variant="h6">
                    Descrição
                  </Typography>
                </TableCell>
                <TableCell>
                  <Typography color="textSecondary" variant="h6">
                    Contábil
                  </Typography>
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              <TableRow sx={{ backgroundColor: 'rgba(0, 0, 0, 0.04)' }}>
                <TableCell></TableCell>
                <TableCell></TableCell>
                <TableCell></TableCell>
                <TableCell></TableCell>
                <TableCell></TableCell>
                <TableCell align="center"><b>{valorTotal.toLocaleString("pt-br", { style: "currency", currency: "BRL" })}</b></TableCell>
                <TableCell></TableCell>
                <TableCell></TableCell>
              </TableRow>
              {rows.map((row) => (
                <StyledTableRow key={row.id}>
                  <StyledTableCell align="center">{format(Date.parse(`${row.release} 12:00:00`), 'dd/MM/yyyy')}</StyledTableCell>
                  <StyledTableCell align="center">{row.patient?.name || row.provider?.name}</StyledTableCell>
                  <StyledTableCell align="center">{row.doc_number}</StyledTableCell>
                  <StyledTableCell align="center">{row.option}</StyledTableCell>
                  <StyledTableCell align="center">{row.nature}</StyledTableCell>
                  <StyledTableCell align="center">{row.value.toLocaleString("pt-br", { style: "currency", currency: "BRL" })}</StyledTableCell>
                  <StyledTableCell align="center">{row.description}</StyledTableCell>
                  <StyledTableCell align="center">
                    {row.nature === "Despesa" &&
                    <Switch size="small" defaultChecked color="success" checked={row.accounting} onChange={(e) => handleChangeChecked(e.target.checked, row.id)}/>}
                  </StyledTableCell>

                </StyledTableRow>
              ))}
            </TableBody>
          </Table>
          <Box
            sx={{
              marginTop: 5,
              display: 'flex',
              justifyContent: "flex-end"
            }}
          >
            <Stack spacing={2}>
              <Pagination count={totalPages} onChange={handleChange} variant="outlined" color="primary" />
            </Stack>
          </Box>
        </Box>
</CardContent>
</Card >
      }
    </Box >
  );
};

export default ControlPage;